import { BadRequest, GenericError, NoDataFound, NotAuthorizeError } from "../../ErrorType";
import { downloadBlob } from "../../Utils";
import * as mime from 'react-native-mime-types';

export const getOrders = async (filters) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/orders`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body: JSON.stringify(filters)
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getOrderDetails = async (orderId) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/order_details?orderId=${orderId}`, {
    method: 'GET',
    headers: {
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const downloadOrders = async (filters) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/orders/download`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce,
    },
    body: JSON.stringify(filters)
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }

  let blob = await response.blob();
  downloadBlob(blob, `orders_${filters.startDate}_${filters.endDate}.${mime.extension(response.headers.get('content-type'))}`);
  return true;
}

export const downloadOrderDetails = async ({ orderId, section, salesOrderItem, deliveryItem }) => {
  const qs = [
    (!!orderId) ? `orderId=${orderId}` : null,
    (!!section) ? `section=${section}` : null,
    (!!salesOrderItem) ? `salesOrderItem=${salesOrderItem}` : null,
    (!!deliveryItem) ? `deliveryItem=${deliveryItem}` : null
  ].filter(value => !!value).join('&');
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/order_details/download?${qs}`, {
    method: 'GET',
    headers: {
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });

  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let blob = await response.blob();
  downloadBlob(blob, `${section}-${orderId}.${mime.extension(response.headers.get('content-type'))}`);
  return true;
}

export const getOrdersAttachment = async (url) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/orders/attachment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body: JSON.stringify(url)
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}